import CostLimit from "@/modules/costLimit/views/CostLimitView.vue";
import CostLimitList from "@/modules/costLimit/views/CostLimitListView.vue";

export const CostLimitRoutes = [
    {
        path: '/cost/limit',
        component: CostLimit,
    },
    {
        path: '/cost/limits',
        component: CostLimitList,
    }
]